import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { checkIfHotjarEnable, dynaTraceGetAction, dynaTraceLeaveAction, timeBetweenDates } from '../utils/helpers';
import history from '../utils/history';
import * as sinisterCardsActions from '../redux/actions/sinister-cards';
import * as constants from '../utils/constants';
import Navbar from '../components/common/Navbar/Navbar';
import Modal from '../components/common/modal/Modal';
import SinisterCard from '../components/content/SinisterCard/SinisterCard';
import RimacTopBar from '../components/common/RimacTopBar/RimacTopBar';
import Tooltip from '../components/common/tooltip';
import IconInfo from '../assets/icons/ic_info_blue.svg';

const modalContent = (
  <>
    <p>
      Para movimientos no reconocidos en tus tarjetas o compras fraudulentas vía
      internet, comunícate con los siguientes canales:
    </p>
    <ul>
      <li>
        Banca por internet.
        <a
          href={constants.LINK_BBVA_BANCA}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            if (checkIfHotjarEnable()) {
              window.digitalData.push({
                action: {
                  group: 'Tramites Siniestros – Protección Tarjeta BBVA',
                  category: 'Reporta siniestro',
                  name: 'Canales Disponibles',
                  label: 'Banca por internet',
                },
                event: 'trackAction',
              });
            }
          }}
        >
          Ver aquí.
        </a>
      </li>
      <li>
        App BBVA.
        <a
          href={constants.LINK_BBVA_BANCA_MOBILE}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            if (checkIfHotjarEnable()) {
              window.digitalData.push({
                action: {
                  group: 'Tramites Siniestros – Protección Tarjeta BBVA',
                  category: 'Reporta siniestro',
                  name: 'Canales Disponibles',
                  label: 'App BBVA',
                },
                event: 'trackAction',
              });
            }
          }}
        >
          Ver aquí.
        </a>
      </li>
      <li>Email: terespondemos@bbva.com</li>
      <li>
        Contact Center: Te puedes comunicar directamente al <b>(01) 595 0000</b>
      </li>
    </ul>
    <p>Para Muerte o invalidez total y permanente:</p>
    <ul>
      <li>
        <a
          href={constants.LINK_BBVA_COBER_INFO}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            if (checkIfHotjarEnable()) {
              window.digitalData.push({
                action: {
                  group: 'Tramites Siniestros – Protección Tarjeta BBVA',
                  category: 'Reporta siniestro',
                  name: 'Canales Disponibles',
                  label: 'Documentos a presentar',
                },
                event: 'trackAction',
              });
            }
          }}
        >
          Ingresa aquí
        </a>
        &nbsp; para ver los documentos a presentar y si tienes alguna duda
        contáctate al <b>(01) 595 0000 - opción 3</b>
      </li>
    </ul>
  </>
);

const SinisterSelectPage = () => {
  const dispatch = useDispatch();
  const selectedServicesStored = useSelector(
    (state) => state.sinisterCards.sinisterList
  );
  const advisorInfo = useSelector( (state) => state.sinisterCards.advisorInfo)
  const coveragesList = useSelector((state) => state.coverages.coveragesList);
  const [selectService, setSelectService] = useState(
    selectedServicesStored || []
  );
  const [isModalOpen, setModalOpen] = useState(false);
  const [currentSinisterID, setCurrentSinisterID] = useState(null);
  const [viewStartTime, setViewStartTime] = useState(new Date());
  const modalEl = useRef(null);
  const [tooltipActive, setTooltipActive] = useState(true);
  const sinisterFileList = useSelector((state) => state.sinisterCards.sinisterFiles);

  useEffect(()=> {
    const filteredList = sinisterFileList.filter(file => file.id !== "7" && file.id !== "6" && file.id !== "5")

    dispatch(
      sinisterCardsActions.setStoreFiles(filteredList)
    );
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setTooltipActive(false);
    }, constants.DELAY_OUT_TOOLTIP);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    return () => {
      const endTime = new Date();
      const userTotalTime = timeBetweenDates(viewStartTime, endTime);

      if (checkIfHotjarEnable()) {
        window.digitalData.push({
          task: {
            name: 'Tiempo registrado - Detalle siniestro',
            time: userTotalTime,
          },
          event: 'trackTimeToComplete',
        });
      }
    };
  }, []);

  useEffect(() => {
    const btnHere = modalEl.current.querySelector('#otro-siniestro');
    const handleClick = () => {
      if (window) {
        window.digitalData.push({
          action: {
            group: 'Tramites Siniestros – Protección Tarjeta BBVA',
            category: 'Detalle de cobertura',
            name: 'Mi siniestro es otro',
            label: 'Aquí',
          },
          event: 'trackAction',
        });
      }
    };

    if (btnHere) {
      btnHere.addEventListener('click', handleClick);
    }

    return () => {
      if (btnHere) btnHere.removeEventListener('click', handleClick);
    };
  }, [selectService, setSelectService, modalEl]);

  const selectItem = (resp) => {
    const otherSinisterWasSelected = selectService.some(
      (sinister) => sinister.code === 'OTRO_SINIESTRO'
    );

    if (resp.code === 'OTRO_SINIESTRO' && !otherSinisterWasSelected) {
      setCurrentSinisterID(resp.sinisterNum);
      setModalOpen(true);
    }

    const isOnArrayService = selectService.find(
      (service) => service.sinisterNum === resp.sinisterNum
    );
    if (isOnArrayService) {
      const filtered = selectService.filter(
        (service) => service.sinisterNum !== resp.sinisterNum
      );
      return setSelectService(filtered);
    }
    setSelectService([...selectService, resp]);

    if (checkIfHotjarEnable()) {
      window.digitalData.push({
        metadata: {
          key: 'Tipo de siniestro – Protección Tarjeta BBVA',
          value: String(resp.title),
        },
        event: 'trackMetadata',
      });

      if (resp.title === 'Mi siniestro es otro') {
        window.digitalData.push({
          action: {
            name: 'web:tramites-siniestros:proteccion-tarjeta:modal-detalle-cobertura',
          },
          event: 'trackVirtual',
        });
      }
    }
  };

  const onOpenSinisterModal = (e, code) => {
    e.stopPropagation();
    setCurrentSinisterID(code);
    setModalOpen(true);
  };

  const onBackHandler = () => {
    dispatch(sinisterCardsActions.reduceStep());
    history.replace('/');
  };

  const onContinueHandler = () => {
    const isSecondServiceSelected =
      selectService.filter((service) => service.code === 'COB01' && service.sinisterNum === '2').length > 0;

    dispatch(sinisterCardsActions.setSinisterList(selectService));

    if (isSecondServiceSelected) {
      const action = dynaTraceGetAction('load otros seguros page');
      dynaTraceLeaveAction(action);
      history.replace('/otros-seguros');
    } else {
      history.replace('/antes-de-comenzar');
    }
  };

  const selectedSinister = coveragesList.find(
    (sin) => sin.sinisterNum === currentSinisterID
  );

  return (
    <>
      <RimacTopBar />
      <div
        data-testid="sinister-select-page"
        className="sinisterSelectPage pageContainer"
      >
        <div className="sinisterSelectPage__left pageContainer__left">
          <div className="titleCont">
            <h1 className="u-mb-24">Seguro de Protección de Tarjetas</h1>
            <p>
              Hola, sabemos que sufriste un siniestro y queremos ayudarte a
              reportarlo.
            </p>
          </div>
        </div>

        <div className="sinisterSelectPage__right pageContainer__right">
          <div className="titleCont">
            <h2 className="u-mb-16">
              Selecciona que sucedió{' '}
              <Tooltip
                title="Importante"
                description={constants.TOOLTIP_MESSAGES.MSG_2}
                active={tooltipActive}
                hidden={!advisorInfo}
              >
                <img src={IconInfo} />
              </Tooltip>
            </h2>
            <p>Puedes seleccionar más de un siniestro.</p>
          </div>

          <div data-testid="sinisters-container" className="sinisterContainer">
            {coveragesList.map((resp) => {
              if (resp.code === 'COB05' || resp.code === 'COB06') return null;
              const isActive =
                selectService.filter(
                  (service) =>
                    Number(service.sinisterNum) === Number(resp.sinisterNum)
                ).length > 0;
              return (
                <SinisterCard
                  key={`sinisterCard-${resp.sinisterNum}`}
                  icon={resp.icon}
                  altText={resp.title}
                  title={resp.title}
                  content={resp.description}
                  itemKey={resp.sinisterNum}
                  onLabelClick={() => selectItem(resp)}
                  onDetailClick={(e) =>
                    onOpenSinisterModal(e, resp.sinisterNum)
                  }
                  isChecked={isActive}
                  detailsActive={resp.code !== 'OTRO_SINIESTRO'}
                />
              );
            })}

            <p className="sepText">También puedes solicitar reembolso de:</p>

            {coveragesList.map((resp) => {
              if (resp.code !== 'COB05' && resp.code !== 'COB06') return null;
              const isActive =
                selectService.filter(
                  (service) =>
                    Number(service.sinisterNum) === Number(resp.sinisterNum)
                ).length > 0;
              return (
                <SinisterCard
                  customClasses={'noBorder'}
                  key={`sinisterCard-${resp.sinisterNum}`}
                  icon={resp.icon}
                  altText={resp.title}
                  title={resp.title}
                  content={resp.description}
                  itemKey={resp.sinisterNum}
                  onLabelClick={() => selectItem(resp)}
                  onDetailClick={(e) =>
                    onOpenSinisterModal(e, resp.sinisterNum)
                  }
                  isChecked={isActive}
                />
              );
            })}
          </div>

          <div className="infoGris u-mt-40">
            <p className="u-mb-8">
              Nombre de la cobertura en tu solicitud-certificado de seguro:
            </p>
            <p>
              (1) Uso indebido por compra fraudulente vía internet. (2)Uso
              indebido. (3)Robo. (4)Uso forzado. (5)Cobertura Patrimonial por
              Transferencia. (6)Reembolso de Gastos. (7)Reembolso de Gastos de
              Hospitalización.
            </p>
          </div>
        </div>

        <div
          data-testid="sinister-detail-modal"
          className="sinisterModal"
          ref={modalEl}
        >
          <Modal
            onLabelClosed={true}
            visible={isModalOpen}
            onToggle={() => setModalOpen(false)}
            className={isModalOpen ? 'sinisterModalMain' : ''}
            onLabelTextClosed=""
            width={'55%'}
          >
            <div className="sinisterModalMain__info">
              <div className="sinisterModalMain__info-container">
                {currentSinisterID === null ? (
                  <>
                    <h1>¿Cómo reportar otro tipo de siniestro?</h1>
                    <div className="sinisterModalMain__info-content">
                      <div>{modalContent}</div>
                    </div>
                  </>
                ) : (
                  <>
                    <h1>Detalle de cobertura</h1>
                    <h4 className="sinisterModalMain__subtitle">
                      {selectedSinister?.code === 'OTRO_SINIESTRO'
                        ? 'Si te pasó otro tipo de siniestro:'
                        : selectedSinister?.title}
                    </h4>
                    <div className="sinisterModalMain__info-content">
                      <div
                      dangerouslySetInnerHTML={{
                        __html: selectedSinister?.modalInfo,
                      }}
                      >
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="sinisterModalMain__info-image">
                <img
                  src={selectedSinister?.modalImg || coveragesList[0]?.modalImg}
                  alt={selectedSinister?.title || 'rimac image'}
                />
              </div>
              <div className="sinisterModalMain__info-shadow"></div>
            </div>
          </Modal>
        </div>

        <Navbar
          navActive
          onBackClick={onBackHandler}
          onContinueClick={onContinueHandler}
          isNextDisabled={selectService.length > 0 ? false : true}
          currentStep={1}
          totalSteps={5}
          stepperText={'VOLVER'}
        />

        <div className="spacingLeft"></div>
      </div>
    </>
  );
};

export default SinisterSelectPage;
